export default __webpack_public_path__ + "assets/images/2.068c29.avif";